export const selectSideImage = state => state.ui.sideImage;
